import * as go from 'gojs';
import { dataLineageDiagramConfig } from '../../../../../../../state/data-lineage-diagram';
import { readPermissionTooltipBinding } from '../tooltips';

const $ = go.GraphObject.make;

export const buttonToolTip = (text: string, textPermissionNotAllowed?: string) =>
  $(
    'ToolTip',
    {
      'Border.fill': dataLineageDiagramConfig.tooltip.background,
    },
    $(
      go.TextBlock,
      {
        stroke: dataLineageDiagramConfig.tooltip.fontColor,
        margin: 1,
      },
      textPermissionNotAllowed
        ? readPermissionTooltipBinding(text, textPermissionNotAllowed)
        : {
            text,
          },
    ),
  );
